// extracted by mini-css-extract-plugin
export default {"banner_container":"ZwHjf","banner":"oCfij","banner__content":"bzbH7"};